import axios from 'axios'

import {
  OWNER_REGISTER_REQUEST,
  OWNER_REGISTER_SUCCESS,
  OWNER_REGISTER_FAIL,
  OWNER_LOGIN_REQUEST,
  OWNER_LOGIN_SUCCESS,
  OWNER_LOGIN_FAIL,
  OWNER_LOGOUT,
  OWNER_DETAILS_FAIL,
  OWNER_DETAILS_REQUEST,
  OWNER_DETAILS_SUCCESS,
  OWNER_UPDATE_PROFILE_REQUEST,
  OWNER_UPDATE_PROFILE_SUCCESS,
  OWNER_UPDATE_PROFILE_FAIL,
  OWNER_DISABLE_REQUEST,
  OWNER_DISABLE_SUCCESS,
  OWNER_DISABLE_FAIL,
  OWNER_DELETE_REQUEST,
  OWNER_DELETE_SUCCESS,
  OWNER_DELETE_FAIL
} from '../constants/ownerConstants.js'

import { API_URL } from '../apiUrl.js'
import { authHeader } from '../utils/authHeader.js'

// Register owner
export const registerOwner = (ownerinfo) => async (dispatch) => {
  try {
    dispatch({ type: OWNER_REGISTER_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/owners/register`,
      ownerinfo,
      config
    )

    dispatch({ type: OWNER_REGISTER_SUCCESS, payload: data })
    dispatch({ type: OWNER_LOGIN_SUCCESS, payload: data })
    localStorage.setItem('ownerInfo', JSON.stringify(data))
  } catch (err) {
    dispatch({
      type: OWNER_REGISTER_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

// Login owner
export const loginOwner = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: OWNER_LOGIN_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/owners/auth`,
      { email, password },
      config
    )

    dispatch({ type: OWNER_LOGIN_SUCCESS, payload: data })

    localStorage.setItem('ownerInfo', JSON.stringify(data))
  } catch (err) {
    dispatch({
      type: OWNER_LOGIN_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}
// Logout owner
export const logoutOwner = (id) => async (dispatch, getState) => {
  localStorage.removeItem('ownerInfo')

  try {
    const {
      ownerLogin: { ownerInfo }
    } = getState()

    const config = { headers: authHeader(ownerInfo) }

    await axios.post(`${API_URL}/owners/logout`, { id }, config)

    dispatch({ type: OWNER_LOGOUT })
    document.location.href = '/'
  } catch (err) {
    dispatch({
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

// Get owner details
export const getOwnerDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: OWNER_DETAILS_REQUEST
    })

    const {
      ownerLogin: { ownerInfo }
    } = getState()

    const config = { headers: authHeader(ownerInfo) }

    const { data } = await axios.get(`${API_URL}/owners/profile/${id}`, config)

    dispatch({
      type: OWNER_DETAILS_SUCCESS,
      payload: data
    })
  } catch (e) {
    dispatch({
      type: OWNER_DETAILS_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Update owner profile
export const updateOwnerProfile = (owner) => async (dispatch, getState) => {
  try {
    dispatch({
      type: OWNER_UPDATE_PROFILE_REQUEST
    })

    const {
      ownerLogin: { ownerInfo }
    } = getState()

    const config = { headers: authHeader(ownerInfo) }

    const { data } = await axios.put(
      `${API_URL}/owners/updprofile/${owner.id}`,
      owner,
      config
    )

    const updatedOwnerInfo = {
      ...data,
      token: ownerInfo?.token
    }

    dispatch({
      type: OWNER_UPDATE_PROFILE_SUCCESS,
      payload: updatedOwnerInfo
    })

    dispatch({
      type: OWNER_LOGIN_SUCCESS,
      payload: updatedOwnerInfo
    })

    localStorage.setItem('ownerInfo', JSON.stringify(updatedOwnerInfo))
  } catch (e) {
    dispatch({
      type: OWNER_UPDATE_PROFILE_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Disable owner account
export const disableOwner = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: OWNER_DISABLE_REQUEST })

    const {
      ownerLogin: { ownerInfo }
    } = getState()

    const config = { headers: authHeader(ownerInfo) }

    await axios.put(`${API_URL}/owners/disable/${id}`, {}, config)

    dispatch({ type: OWNER_DISABLE_SUCCESS })
  } catch (e) {
    dispatch({
      type: OWNER_DISABLE_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}

// Delete owner account
export const deleteOwner = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: OWNER_DELETE_REQUEST })

    const {
      ownerLogin: { ownerInfo }
    } = getState()

    const config = { headers: authHeader(ownerInfo) }

    await axios.delete(`${API_URL}/owners/delete/${id}`, config)

    dispatch({ type: OWNER_DELETE_SUCCESS })
  } catch (e) {
    dispatch({
      type: OWNER_DELETE_FAIL,
      payload:
        e.response && e.response.data.message
          ? e.response.data.message
          : e.message
    })
  }
}
